var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTilePurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#C175E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91614 1.52368L11.5525 7.7833H2.27975L6.91614 1.52368Z",
    fill: "#A652C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91442 13.9445L2.27803 7.68484L11.5508 7.68484L6.91442 13.9445Z",
    fill: "#A652C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91468 26.3656L11.5511 32.6252H2.27829L6.91468 26.3656Z",
    fill: "#A652C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91296 38.7866L2.27656 32.527L11.5493 32.527L6.91296 38.7866Z",
    fill: "#A652C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91419 13.9457L11.5506 20.2053H2.2778L6.91419 13.9457Z",
    fill: "#B264D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91296 26.3685L2.27656 20.1089L11.5493 20.1089L6.91296 26.3685Z",
    fill: "#B264D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4633 1.52368L30.0997 7.7833H20.8269L25.4633 1.52368Z",
    fill: "#A652C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.462 13.9437L20.8256 7.68411L30.0984 7.68411L25.462 13.9437Z",
    fill: "#A652C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4642 26.3656L30.1006 32.6252H20.8278L25.4642 26.3656Z",
    fill: "#A652C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.462 38.7856L20.8256 32.526L30.0984 32.526L25.462 38.7856Z",
    fill: "#A652C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4633 13.9457L30.0997 20.2053H20.8269L25.4633 13.9457Z",
    fill: "#B264D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.462 26.3677L20.8256 20.1081L30.0984 20.1081L25.462 26.3677Z",
    fill: "#B264D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1886 1.52368L20.825 7.7833H11.5522L16.1886 1.52368Z",
    fill: "#B264D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1876 13.9445L11.5512 7.68484L20.824 7.68484L16.1876 13.9445Z",
    fill: "#B264D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1881 26.3656L20.8245 32.6252H11.5517L16.1881 26.3656Z",
    fill: "#B264D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1876 38.7866L11.5512 32.527L20.824 32.527L16.1876 38.7866Z",
    fill: "#B264D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1886 13.9457L20.825 20.2053H11.5522L16.1886 13.9457Z",
    fill: "#A652C8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1876 26.3685L11.5512 20.1089L20.824 20.1089L16.1876 26.3685Z",
    fill: "#A652C8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7352 1.52368L39.3716 7.7833H30.0988L34.7352 1.52368Z",
    fill: "#B264D2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7355 13.9445L30.0991 7.68484L39.3719 7.68484L34.7355 13.9445Z",
    fill: "#B264D2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.736 26.3656L39.3724 32.6252H30.0996L34.736 26.3656Z",
    fill: "#B264D2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7352 38.7856L30.0988 32.526L39.3716 32.526L34.7352 38.7856Z",
    fill: "#B264D2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7352 13.9457L39.3716 20.2053H30.0988L34.7352 13.9457Z",
    fill: "#A652C8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7355 26.3685L30.0991 20.1089L39.3719 20.1089L34.7355 26.3685Z",
    fill: "#A652C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilePurple);
export default __webpack_public_path__ + "static/media/tile-purple.270f65d5.svg";
export { ForwardRef as ReactComponent };